import {
    useContext,
    useState
} from 'react';
import { useRouter } from 'next/router';

import ReCAPTCHA from 'react-google-recaptcha';

import { 
    Button, 
    Divider, 
    TextField
} from '@mui/material';

import { RequestNextApi } from '../../api/Request';
import { ProgressContext } from '../../components/Context/progressContext';
import MarketingNavigation from '../../navigation/marketing';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import Image from 'next/image';
import { GlobalsContext } from '../../components/Context/globalsContext';
import { UserContext } from '../../components/Context/userContext';
import { setCookie } from '../../utils/cookieHandle';

export default function LoginLink() {
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const { update: updateGlobals, state: globalsContext } = useContext(GlobalsContext);
    const { update: updateUser, state: userContext } = useContext(UserContext);

    const [recaptchaSuccess, setRecaptchaSuccess] = useState(false);

    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [codeSent, setCodeSent] = useState(false);

    const router = useRouter();

    const onChangeCaptcha = (value) => {
        if (value) {
          setRecaptchaSuccess(true);
        } else {
          setRecaptchaSuccess(false);
        }
    };

    const handleGetCode = async () => {
        if (!email) {
            ShowNotification.error('Email is missing');
            return;
        }
        updateProgress({ isLoading: true });
        try {
            const result = await RequestNextApi.post('/login/generate-auth-link',
                {
                    email
                }
            );
            if (result.data.success) {
                console.log(result.data);
                setCodeSent(true);
                ShowNotification.success(result.data.message);
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (error) {
            ShowNotification.error('Request failed');
        }
        updateProgress({ isLoading: false });
    }

    const handleVerifyCode = async () => {
        if (!code) {
            ShowNotification.error('Code is missing');
            return;
        }
        updateProgress({ isLoading: true });
        try {
            const res = await RequestNextApi.post('/login/email-login',
                {
                   user_email: email,
                   one_time_code: code
                }
            );
            if (res.data.success) {
                setCookie('jwt-token', res.data.access_token.jwtToken);
                setCookie('jwt-refresh-token', res.data.access_token.refreshToken, { expires: 3 });
                ShowNotification.success(res.data.message);
                const userInfo = await RequestNextApi.post('/user/user-fetch2',
                    {
                        jwtToken: res.data.access_token.jwtToken
                    }
                );
                const globalInfo = await RequestNextApi.post('/global-variables',
                    {
                        jwtToken: res.data.access_token.jwtToken
                    }
                );

                if (globalInfo.data.success) {
                    updateGlobals({ globals: globalInfo.data.globals })
                }
                if (userInfo.data.success) {
                    updateUser({ user: userInfo.data.user });
                    updateProgress({ isLoading: false });
                    router.push('/members/home');
                }
            } else {
                updateProgress({ isLoading: false });
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            updateProgress({ isLoading: false });
            ShowNotification.error('Error while sending the request');
        }
    }

    return (
      <MarketingNavigation>
          <div className="min-h-full flex flex-col justify-center items-center py-12 sm:px-6 lg:px-8">
              <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
                  <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
                      <div className="flex flex-row justify-center items-center w-full pb-5 ">
                          <Image src="/static/images/kingdomadvisors.png" alt="Kingdom Advisor Logo" width={200} height={81}/>
                      </div>
                      <div className="my-5">
                          <div className="text">Have a code sent to your email that lets you log into your account.</div>
                          <div className="space-y-3 mt-5">
                              <div className="mt-5">
                                  <TextField
                                    type="email"
                                    label="Email"
                                    color="third"
                                    size="small"
                                    fullWidth
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    disabled={codeSent}
                                    variant="outlined"
                                  />
                              </div>
                          </div>
                      </div>
                      {codeSent ? 
                        <>
                         <div className="mt-5">
                                  <TextField
                                    type="text"
                                    label="Code"
                                    color="third"
                                    size="small"
                                    fullWidth
                                    id="code"
                                    name="code"
                                    value={code}
                                    onChange={e => setCode(e.target.value)}
                                    variant="outlined"
                                  />
                              </div>
                              <Button
                                className="bg-secondary-500 hover:bg-secondary-500 w-full mt-5"
                                variant="contained"
                                onClick={handleVerifyCode}
                            >
                                Submit
                            </Button>
                        </> :
                        <>
                            <div className="flex justify-center mt-5">
                                <ReCAPTCHA
                                    sitekey={process.env.RECAPTCHA_SITE_KEY}
                                    onChange={onChangeCaptcha}
                                />
                            </div>
                            <Button
                                className="bg-secondary-500 hover:bg-secondary-500 w-full mt-5"
                                variant="contained"
                                onClick={handleGetCode}
                                disabled={!recaptchaSuccess}
                            >
                                Get the Code
                            </Button>
                        </>
                      }
                      <div className="flex justify-center text-sm mt-1 italic">Code expires after 10 minutes.</div>

                      <div className="flex items-center justify-center mt-5">
                          <div className="text-sm">
                              <a href="/login" rel="noreferrer" target="_blank" className="fort-medium text-secondary-500 m-0 underline">
                                  Return to Login
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </MarketingNavigation>
    )
}

LoginLink.getLayout = page => <>{page}</>;
LoginLink.isPublic = true;
